export default __webpack_public_path__ + "static/media/Transactions.088ec1d0.xlsx";